import(/* webpackMode: "eager" */ "/app/src/app/network-dao/organization/page.jsx")